import { useState } from 'react'
import SupportPanel from '@/components/support/SupportPanel'
import { useAuth } from '@/lib/auth-context'

export default function SponsorSupportDock() {
  const { session, profile } = useAuth()
  const token = session?.access_token || ''
  const [open, setOpen] = useState(false)

  if (!token) return null

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {open ? (
        <div className="w-full max-w-xl rounded-3xl border border-sand/80 bg-white/90 shadow-2xl">
          <SupportPanel
            roleLabel="Sponsor"
            intro="Get quick help with pledges, credits, and marketplace orders."
            defaultCategory="sponsor_support"
            contextMeta={{ surface: 'sponsor_portal', sponsor_id: (profile?.id as string) || undefined }}
            onClose={() => setOpen(false)}
          />
        </div>
      ) : null}

      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center gap-2 rounded-full border border-brick bg-brick px-4 py-2 text-sm font-semibold uppercase tracking-wide text-white shadow-lg transition hover:bg-brick/90"
      >
        {open ? 'Hide support' : 'Contact support'}
      </button>
    </div>
  )
}
